export default {"src":"/_next/static/media/hyperlink_icon_white.5d697533.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};